import { render, staticRenderFns } from "./lost.vue?vue&type=template&id=b039df1c&scoped=true"
import script from "./lost.vue?vue&type=script&lang=js"
export * from "./lost.vue?vue&type=script&lang=js"
import style0 from "./lost.vue?vue&type=style&index=0&id=b039df1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b039df1c",
  null
  
)

export default component.exports